// Production uses one page-lifetime switch from SSI portal-next.json.
// An explicit shell:true selects SP4 Header, Home and Footer together.
const DISABLED_SP4_SURFACES = Object.freeze({ shell: false });

const isExplicitlyEnabled = (value, surface) =>
    value !== null &&
    typeof value === 'object' &&
    !Array.isArray(value) &&
    value[surface] === true;

export const normalizeSp4SurfaceRollout = (value) => {
    return Object.freeze({
        shell: isExplicitlyEnabled(value, 'shell'),
    });
};

export const readInjectedSp4SurfaceRollout = (
    documentImpl = globalThis.document,
) => {
    const raw = documentImpl
        ?.getElementById('portalNext')
        ?.textContent?.trim();

    if (!raw) {
        return null;
    }

    try {
        return JSON.parse(raw);
    } catch {
        return null;
    }
};

export const createSp4SurfaceRollout = (readConfig) => {
    let snapshot = DISABLED_SP4_SURFACES;
    let initialized = false;

    return {
        initialize: () => {
            if (!initialized) {
                initialized = true;

                try {
                    snapshot = normalizeSp4SurfaceRollout(readConfig());
                } catch {
                    snapshot = DISABLED_SP4_SURFACES;
                }
            }

            return snapshot;
        },
        isEnabled: (surface) => snapshot[surface] === true,
    };
};

const currentRollout = createSp4SurfaceRollout(
    readInjectedSp4SurfaceRollout,
);

export const initializeSp4SurfaceRollout = () => currentRollout.initialize();
export const isSp4SurfaceEnabled = (surface) =>
    currentRollout.isEnabled(surface);
